import React, { Suspense } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useLocation
} from "react-router-dom";
import Analytics from "react-router-ga";
import Skeleton from "react-loading-skeleton";
const Home = React.lazy(() => import("./routes/Home"));
const Warehouse = React.lazy(() => import("./routes/Warehouse"));
const basename = "/amazon-address-list";

export default function App() {
  return (
    <Router basename={basename}>
      <Suspense fallback={<Fallback />}>
        <ScrollToTop />
        <Analytics
          id="UA-98820146-12"
          basename={basename}
          debug={process.env.NODE_ENV !== "production"}
          trackPathnameOnly={true}
        >
          <Switch>
            <Route exact path="/" component={Home} />
            <Route path="/fulfillment-center/:id" component={Warehouse} />
          </Switch>
        </Analytics>
      </Suspense>
    </Router>
  );
}

function Fallback() {
  return <Skeleton count={50} />;
}

function ScrollToTop() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
